export default __webpack_public_path__ + "static/media/materializecss-logo.b69ebbac.png";